import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import { FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { MASTER_APIs } from "apihandlers/master";
import AutoComplete from "components/Custom/AutoComplete";
import { GEO_APIs } from "apihandlers/geography";
import { DateFunctions } from "common/datefunctions";

const Incentive = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>();
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [states, setStates] = useState<any>([]);
  const [centralZone, setCentralZone] = useState<any>([]);
  const [regions, setRegions] = useState<any>([]);
  const [regionZone, setRegionZone] = useState<any>([]);
  const [city, setCity] = useState<any>([]);
  const [districts, setDistricts] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [designation, setDesignation] = useState<any>([]);
  const [itemsRow, setItemRow] = useState<any>([]);
  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "designationName",
      name: LABELS.DESIGNATION,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "grade",
      name: LABELS.GRADE,
      width: "15%",
      type: "number",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "centralZoneName",
      name: LABELS.CENTRAL_ZONE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "stateName",
      name: LABELS.STATE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "districtName",
      name: LABELS.DISTRICT,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "regionName",
      name: LABELS.REGION,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "cityName",
      name: LABELS.CITY,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },

    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "5%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const itemsColumn = [
    {
      key: "fromDate",
      name: LABELS.FROM_DATE,
      width: "15%",
      type: "datetime",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "toDate",
      name: LABELS.TO_DATE,
      width: "15%",
      type: "datetime",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "salesMinimum",
      name: LABELS.SALES_MINIMUM,
      width: "15%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "salesUpper",
      name: LABELS.SALES_UPPER,
      width: "15%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "amount",
      name: LABELS.AMOUNT,
      width: "20%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },

    {
      key: "percentage",
      name: LABELS.PERCENTAGE,
      width: "20%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
  ];

  const stateRef: any = useRef(null);
  const centralZoneRef: any = useRef(null);
  const regionRef: any = useRef(null);
  const regionZoneRef: any = useRef(null);
  const cityRef: any = useRef(null);
  const districtRef: any = useRef(null);
  const itemGridRef: any = useRef(null);
  const designationRef: any = useRef(null);

  useEffect(() => {
    if (loading) {
      getCentralZones();
    }
  }, [loading]);

  const getCentralZones = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      minResponse: true,
    };
    GEO_APIs.getCentralZones(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.centralZoneName,
          };
        });
        setCentralZone(list);
        getUserDesignations();
      }
    });
  };

  const getUserDesignations = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      minResponse: true,
    };
    MASTER_APIs.getUserDesignations(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.designation,
          };
        });
        setDesignation(list);
        getRows();
      }
    });
  };

  const getStates = async (centralZoneId) => {
    let stateList = [];
    try {
      const args = {
        centralZoneId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getStates(args);
      stateList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.stateName,
        };
      });
    } catch (error) {}
    return stateList;
  };

  const getDistricts = async (stateId) => {
    let districtList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getDistricts(args);
      districtList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.districtName,
        };
      });
    } catch (error) {}
    return districtList;
  };

  const getRegionZone = async (stateId) => {
    let regionZoneList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegionZones(args);
      regionZoneList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionZoneName,
        };
      });
    } catch (error) {}
    return regionZoneList;
  };

  const getRegion = async (districtId) => {
    let regionList = [];
    try {
      const args = {
        districtId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegions(args);
      regionList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionName,
        };
      });
    } catch (error) {}
    return regionList;
  };

  const getCities = async (regionId) => {
    let cityList = [];
    try {
      const args = {
        regionId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCities(args);
      cityList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.cityName,
        };
      });
    } catch (error) {}
    return cityList;
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getIncentives(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setItemRow(row.incentive ? JSON.parse(row.incentive) : []);
    console.log(selectedRow);
  };

  const manageRecord = () => {
    const enteredOn = (
      document.getElementById("enteredOn") as HTMLInputElement
    ).value.trim();
    const stateId = stateRef.current.selectedValue.id;
    const centralzoneId = centralZoneRef.current.selectedValue.id;
    const regionzoneId = regionZoneRef.current.selectedValue.id;
    const regionId = regionRef.current.selectedValue.id;
    const cityId = cityRef.current.selectedValue.id;
    const districtId = districtRef.current.selectedValue.id;

    const grade = (
      document.getElementById("grade") as HTMLInputElement
    ).value.trim();
    const designationId = designationRef.current.selectedValue.id;

    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";
    //todo:Validations needs to be done

    // Validations
    let errors = [];
    if (enteredOn === "") {
      errors.push({
        id: "enteredOn",
        msg:
          "<span class='bold'>" +
          LABELS.ENTERED_ON +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      enteredOn,
      stateId,
      centralzoneId,
      regionzoneId,
      regionId,
      cityId,
      districtId,
      grade: Number(grade),
      designationId,
      activeStatus,
      incentive: itemGridRef.getRowData(),
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageIncentive(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setItemRow([]);
  };

  const handleCentralZoneChange = async (e, f) => {
    if (f.id) {
      const res = await getStates(f.id);
      setStates(res);
      setDistricts([]);
      setRegionZone([]);
      setRegions([]);
      setCity([]);
    }
  };

  const handleStateChange = async (e, f) => {
    if (f.id) {
      const res = await getDistricts(f.id);
      setDistricts(res);
      setRegions([]);
      setCity([]);
    }
    if (f.id) {
      const res = await getRegionZone(f.id);
      setRegionZone(res);
    }
  };

  const handleDistrictChange = async (e, f) => {
    if (f.id) {
      const res = await getRegion(f.id);
      setRegions(res);
      setCity([]);
    }
  };

  const handleRegionChange = async (e, f) => {
    if (f.id) {
      const res = await getCities(f.id);
      setCity(res);
    }
  };

  const getDeaultItemRow = () => {
    const newRow: any = {
      id: "1." + (itemGridRef.getRowData().length + 1).toString(),
    };
    return newRow;
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.INCENTIVE}</li>
        </ul>
        <h4>{TITLES.INCENTIVE}</h4>
        <p>{SUB_TITLES.INCENTIVE}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"incentive"}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.INCENTIVE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.INCENTIVE + ": " + selectedRow.designationName
              : "Add New " + LABELS.INCENTIVE
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexRowJustify">
            <div className="formGroup width30 ">
              <TxtRow
                id={"enteredOn"}
                type={"date"}
                label={LABELS.ENTERED_ON}
                required={true}
                defaultValue={
                  selectedRow.enteredOn
                    ? DateFunctions.getFormatedDate(
                        selectedRow.enteredOn,
                        FORMATS.SQL_DATE_ONLY,
                        FORMATS.SQL_DATE_ONLY
                      )
                    : DateFunctions.getDate(
                        "today",
                        "from",
                        FORMATS.SQL_DATE_ONLY
                      )
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>
                {LABELS.DESIGNATION}
                {/* <span className="red">{" *"}</span> */}
              </label>
              <AutoComplete
                list={designation}
                childRef={designationRef}
                defaultValue={
                  selectedRow.designationId
                    ? {
                        id: selectedRow.designationId,
                        label: selectedRow.designationName,
                      }
                    : null
                }
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"grade"}
                type={"number"}
                label={LABELS.GRADE}
                defaultValue={selectedRow.grade || 0}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>{LABELS.CENTRAL_ZONE}</label>
              <AutoComplete
                list={centralZone}
                childRef={centralZoneRef}
                defaultValue={
                  selectedRow.centralzoneId
                    ? {
                        id: selectedRow.centralzoneId,
                        label: selectedRow.centralZoneName,
                      }
                    : null
                }
                disabled={isSubmit}
                onChange={handleCentralZoneChange}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {LABELS.STATE}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={states}
                childRef={stateRef}
                defaultValue={
                  selectedRow.stateId
                    ? {
                        id: selectedRow.stateId,
                        label: selectedRow.stateName,
                      }
                    : null
                }
                onChange={handleStateChange}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.DISTRICT}</label>
              <AutoComplete
                list={districts}
                childRef={districtRef}
                defaultValue={
                  selectedRow.districtId
                    ? {
                        id: selectedRow.districtId,
                        label: selectedRow.districtName,
                      }
                    : null
                }
                onChange={handleDistrictChange}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>
                {LABELS.REGION_ZONE}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={regionZone}
                childRef={regionZoneRef}
                defaultValue={
                  selectedRow.regionId
                    ? {
                        id: selectedRow.regionId,
                        label: selectedRow.regionName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {LABELS.REGION}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={regions}
                childRef={regionRef}
                defaultValue={
                  selectedRow.regionId
                    ? {
                        id: selectedRow.regionId,
                        label: selectedRow.regionName,
                      }
                    : null
                }
                onChange={handleRegionChange}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>{LABELS.CITY}</label>
              <AutoComplete
                list={city}
                childRef={cityRef}
                defaultValue={
                  selectedRow.cityId
                    ? {
                        id: selectedRow.cityId,
                        label: selectedRow.cityName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup required width30 ">
              <label>{LABELS.ACTIVE_STATUS}</label>
              <span className="red">{" *"}</span>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div
            className="grid"
            style={{
              width: "100%",
              height: "80%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ExcelGrid
              id={"items"}
              height={600}
              childRef={itemGridRef}
              cols={itemsColumn}
              rows={itemsRow}
              exportOption={false}
              newRowOption={false}
              getDefaultNewRow={getDeaultItemRow}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Incentive);
